import { styled } from "@mui/material";
import Component from "./component";

export default styled(Component)(({ theme }) => ({
  width: "100%",
  ".success-cont": {
    margin: theme.spacing(1),
  },
}));
